export default {
  mapLeftClick: {
    placeInfo: 'Details zum Ort',
    polygonArea: 'Polygonfläche',
    placeInsidePolygon: 'Details zum Ort (im Polygon)',
    copyLatlng: 'Im Format "Breitengrad, Längengrad" kopieren',
    copyLnglat: 'Im format "Längengrad, Breitengrad" kopieren',
    directionsToClickedPoint: 'Route zum angeklickten Ort',
    latlngCopied: 'Breiten- und Längengrad kopiert',
    lnglatCopied: 'Längen- und Breitengrad kopiert'
  }
}
